import React from 'react';
import PropTypes from 'prop-types';

import { IconClose, IconCheck } from '../Icons';
import { StyledButton } from './CloseBtnStyles';

var _ref = React.createElement(IconClose, null);

var _ref2 = React.createElement(IconCheck, null);

var CloseBtn = function CloseBtn(props) {
  return React.createElement(
    StyledButton,
    {
      onClick: props.onClick,
      visible: props.visible,
      btnType: props.btnType,
      showMobileFilterCheck: props.showMobileFilterCheck,
      'aria-label': 'Close ' + props.btnType
    },
    _ref,
    _ref2
  );
};

CloseBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  btnType: PropTypes.oneOf(['Cart', 'Mobile Filter']),
  showMobileFilterCheck: PropTypes.bool
};

export default CloseBtn;